import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material/styles";
import cl from "classnames";
import { Provider } from "unstated";
import SrpContainer from "../containers/SrpContainer";
import RightCol from "./RightCol/index";
import { reportError } from "venuescanner-js/react/services/errorService";
import ErrorPage from "venuescanner-js/react/components/ErrorPage";
import SpaceList from "./SpaceList";
import TopHeader from "./Filters/TopHeader";
import TagShape from "venuescanner-js/react/shapes/Tag";
import { unTransposeQuery } from "../helpers/updateUrl";
import { SrpContext } from "./Filters/context";
import { subscribe } from "venuescanner-js/react/helpers";
import Seo from "../components/RightCol/Seo";
import { theme } from "venuescanner-js/theme";

const Srp = subscribe({ SrpContainer })(
  ({
    popState,
    srpContainer: {
      state: { data },
    },
  }) => {
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    const [mapOpen, setMapOpen] = useState(false);
    const hasResults = data.all > 0;
    useEffect(() => {
      if (typeof window === "undefined") return; // SSR

      const listener = (e) => {
        popState(e.state);
      };
      window.addEventListener("popstate", listener);
      return () => {
        window.removeEventListener("popstate", listener);
      };
    }, [popState]);

    const isWideEnough = true; // isDesktop()
    // console.log('SRP')
    return (
      <ThemeProvider theme={theme}>
        <SrpContext.Provider
          value={{
            mobileFiltersOpen,
            setMobileFiltersOpen,
            mapOpen,
            setMapOpen,
          }}
        >
          <Seo />
          <section
            className={cl("ux-section srp-container", {
              noResults: !hasResults,
            })}
          >
            {!isWideEnough && mapOpen && <TopHeader />}
            <div className="srp-results">
              {(isWideEnough || !mapOpen) && <TopHeader />}
              <SpaceList />
            </div>

            <RightCol />
          </section>
        </SrpContext.Provider>
      </ThemeProvider>
    );
  }
);

Srp.propTypes = {
  popState: PropTypes.func.isRequired,
};

let srpContainer = null;
const SrpProvider = ({
  location,
  noResults,
  isAdmin,
  superLoggedIn,
  data,
  srps,
  sublocations,
  alsoSearchedFor,
  srpsCounter,
  query,
  styles,
  attrs,
  international,
  dynamicSearch,
}) => {
  if (typeof window === "undefined" || srpContainer === null)
    srpContainer = new SrpContainer({
      location,
      isAdmin,
      superLoggedIn,
      data,
      srps,
      sublocations,
      alsoSearchedFor,
      srpsCounter,
      noResults,
      query,
      styles,
      attrs,
      international,
      dynamicSearch,
    });
  useEffect(() => {
    if (typeof window === "undefined") return; // SSR
    window.srpContainer = srpContainer;

    return () => {
      delete window.srpContainer;
      srpContainer = null;
    };
  }, []);
  return (
    <Provider inject={[srpContainer]}>
      <Srp
        popState={(query) => {
          query = unTransposeQuery(query);
          if (srpContainer) {
            if (query) srpContainer.setState({ query });
            srpContainer.refresh();
          }
        }}
      />
    </Provider>
  );
};

SrpProvider.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }),
  dynamicSearch: PropTypes.bool,
  noResults: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,
  superLoggedIn: PropTypes.bool.isRequired,
  data: PropTypes.object,
  srps: PropTypes.array,
  sublocations: PropTypes.array,
  alsoSearchedFor: PropTypes.array,
  srpsCounter: PropTypes.number,
  query: PropTypes.object,
  styles: PropTypes.arrayOf(TagShape.isRequired).isRequired,
  attrs: PropTypes.arrayOf(TagShape.isRequired).isRequired,
  international: PropTypes.bool,
};

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    reportError("SRP", error, errorInfo);
  }

  render() {
    const { state, props } = this;
    if (state.error) return <ErrorPage />;
    return <SrpProvider {...props} />;
  }
}
export default ErrorBoundary;
